export default {
    create_edit_webhook_create_title: 'Crear Webhook',
    create_edit_webhook_edit_title: 'Editar Webhook',
    create_edit_webhook_name: 'Nombre',
    create_edit_webhook_action: 'Acción (URL del Webhook)',
    create_edit_webhook_event_type: 'Tipo de Evento',
    create_edit_webhook_status: 'Activo',
    create_edit_webhook_headers: 'Avanzado: Encabezados (Opcional)',
    create_edit_webhook_headers_help: 'Encabezados personalizados opcionales en formato JSON',
    create_edit_webhook_name_required: 'El nombre es requerido',
    create_edit_webhook_url_required: 'La URL es requerida',
    create_edit_webhook_url_invalid: 'Formato de URL inválido',
    create_edit_webhook_event_type_required: 'El tipo de evento es requerido',
    create_edit_webhook_created: 'Webhook creado exitosamente',
    create_edit_webhook_updated: 'Webhook actualizado exitosamente',
    create_edit_webhook_duplicate_error: 'Ya existe un webhook para este tipo de evento. Edítalo en su lugar.',
    create_edit_webhook_invalid_params: 'Parámetros inválidos. Por favor verifica tu entrada.',
    create_edit_webhook_unauthorized: 'No estás autorizado para realizar esta acción.',
    create_edit_webhook_record_not_exist: 'El webhook o distribuidor no existe.',
    create_edit_webhook_error: 'Error al guardar el webhook. Por favor intenta de nuevo.',
};
